// Registers the service worker that makes the installed app work offline.
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker').catch((error) => {
      console.error('Service worker registration failed:', error)
    })
  })
}

// Called on sign out so the next person on this device can't scroll a cached album.
export function clearPrivateCaches() {
  navigator.serviceWorker?.controller?.postMessage('clear-private-caches')
}

export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  )
}
